var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMegaphone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.6666 7.66675C12.6666 7.11446 13.1143 6.66675 13.6666 6.66675C14.2189 6.66675 14.6666 7.11446 14.6666 7.66675C14.6666 8.21903 14.2189 8.66675 13.6666 8.66675C13.1143 8.66675 12.6666 8.21903 12.6666 7.66675Z",
    fill: "#3F8CFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.98701 9.20264L4.47698 11.6525C4.51739 11.8546 4.69484 12 4.90093 12C5.13971 12 5.33329 11.8065 5.33329 11.5677V9.33338H6.66662V11.5677C6.66662 12.5429 5.87609 13.3334 4.90093 13.3334C4.05926 13.3334 3.3346 12.7393 3.16954 11.914L2.67957 9.46412L3.98701 9.20264Z",
    fill: "#3F8CFF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14 5.0058C14 3.20365 12.044 2.08179 10.4885 2.9918L7.88962 4.51218C6.97047 5.0499 5.92477 5.33331 4.85988 5.33331H3.66671C2.37804 5.33331 1.33337 6.37798 1.33337 7.66664C1.33337 8.95531 2.37804 9.99998 3.66671 9.99998H4.85717C5.9236 9.99998 6.97076 10.2842 7.89083 10.8234L10.4869 12.3448C12.0425 13.2564 14 12.1347 14 10.3317V5.0058ZM11.1618 4.14266C11.8284 3.75265 12.6667 4.23345 12.6667 5.0058V10.3317C12.6667 11.1044 11.8277 11.5852 11.1611 11.1945L8.56498 9.67306C8.17158 9.44251 7.75916 9.2501 7.33337 9.09735V6.23691C7.75838 6.08463 8.1701 5.89283 8.5629 5.66304L11.1618 4.14266ZM6.00004 6.57747C5.62425 6.63662 5.24308 6.66664 4.85988 6.66664H3.66671C3.11442 6.66664 2.66671 7.11436 2.66671 7.66664C2.66671 8.21893 3.11442 8.66664 3.66671 8.66664H4.85717C5.24129 8.66664 5.62338 8.69682 6.00004 8.75625V6.57747Z",
    fill: "#3F8CFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMegaphone);
export default __webpack_public_path__ + "static/media/megaphone.f0fd2fa3bfc64cf916a2fabe42a7fb99.svg";
export { ForwardRef as ReactComponent };